// "Request a file" used to silently mint a bare file — the team then chased
// the agent for the format, deadline, trust status, and the rest. This dialog
// asks those questions AT request time (all optional, so it never blocks a
// request) and hands the answers to requestSellerFile/requestBuyerFile.
import { useState } from "react";
import FileRequestDetailsFields from "./FileRequestDetailsFields";

export default function FileRequestDetailsDialog({
  side = "seller",
  busy = false,
  onCancel,
  onSubmit,
}) {
  const [details, setDetails] = useState({});

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={busy ? undefined : onCancel}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 py-3 border-b">
          <h3 className="font-semibold text-slate-900 text-sm">
            {side === "seller" ? "Request Listing File" : "Request Buyer File"}
          </h3>
          <p className="text-xs text-slate-400 mt-0.5">
            These details go to the team building the file. Fill in what you
            know — anything blank stays open for later.
          </p>
        </div>
        <div className="p-5 overflow-y-auto">
          <FileRequestDetailsFields
            side={side}
            value={details}
            onChange={setDetails}
          />
        </div>
        <div className="flex items-center justify-end gap-2 px-5 py-3 border-t bg-slate-50">
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            className="px-4 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={() => onSubmit?.(details)}
            className="px-4 py-2 text-sm font-semibold text-white bg-themeColor rounded-lg hover:opacity-90 disabled:opacity-50"
          >
            {busy ? "Requesting…" : "Request File"}
          </button>
        </div>
      </div>
    </div>
  );
}
